import React, { Component, useState,useEffect  } from 'react';
import cookie from 'react-cookies';


class Voting extends Component {
	constructor(props){
		super(props);
		this.state = {
			alldata: null,
			showq: false,
			pass:'',
		}
		this.getVotes = this.getVotes.bind(this);
		this.vote = this.vote.bind(this);
		this.openvote = this.openvote.bind(this);
	}

	componentDidMount(){
		this.getVotes(this.props.vid);

	}

	triggerEvent (SheVoteAction, SheVoteValue) {
		dataLayer.push({event: "she vote", virtualPageURL: "MERROR - "+this.state.alldata.name, SheVoteAction, SheVoteValue})
	}

	getVotes(vid){
		let that = this;
		this.getPass();
		var myHeaders = new Headers();
		myHeaders.append('pragma', 'no-cache');
		myHeaders.append('cache-control', 'no-cache');
		fetch('/wp-json/she-rest-api/getVoteDetails/'+vid,{
			method:"GET",
			headers: myHeaders
		}).then(function(res){
			return res.json();
		})
		.then(function(response){
			that.setState({alldata: response});
			return response;
		}).catch(function(error){
			console.error(error);
		});
	}

	refresh(){
		let that = this;
		var myHeaders = new Headers();
		myHeaders.append('pragma', 'no-cache');
		myHeaders.append('cache-control', 'no-cache');
		this.getPass();
		fetch('/wp-json/she-rest-api/getVoteDetails/'+this.props.vid,{
			method:"GET",
			headers: myHeaders
		}).then(function(res){
			return res.json();
		})
		.then(function(response){
				that.setState({alldata: response});
				that.forceUpdate()
				return response;
			}).catch(function(error){
				console.error(error);
		});
	}

	getPass(){
		let that = this;
		fetch('/wp-json/she-rest-api/GEV',{
			method:"POST",
		}).then(function(res){
			return res.json();
		})
			.then(function(response){
				that.setState({pass: encodeURIComponent(response[0])});
				return ;
			}).catch(function(error){
			console.error(error);
		});
	}

	vote(index, oindex, endday) {
		if (  (+(new Date(endday))) - (+(new Date())) <= 0){
			alert('是次投票活動已經結束，下一個投票即將開始。')
			return;
		}
		this.getPass();
		this.triggerEvent("Voting", index);
		let that = this;
		var time = parseInt(cookie.load(this.props.vid,true));
		if (isNaN(time)){
			time = 0;
		}
		if (time >= 3){
			alert('每24小時同一個題目只能投票3次')
			return ;
		}
		fetch('/wp-json/she-rest-api/sheVote/'+this.props.vid+'/'+this.state.pass+'/'+index,{
			method:"POST",
		})
		document.querySelector("#vote" + this.props.vid + "-" + index + " .voted").style.opacity = "1";
		document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.top = "0%";
		//document.querySelector("#vote"+this.props.vid+"-"+index+" .vote-whole").style.top = "100%";
		var date = new Date();
		date.setTime(date.getTime()+(24*60*60*1000));
		cookie.save(this.props.vid, time+1,{path:"/",expires:date});
		setTimeout(() => {
			document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.opacity = "0.3";
			document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.top = "100%";
			//document.querySelector("#vote"+this.props.vid+"-"+index+" .vote-whole").style.top = "0%";
			this.refresh();
		}, 1400);

		setTimeout(
			() => {
				document.querySelector("#vote" + this.props.vid + "-" + index + " .voted").style.opacity = "1";
				//document.querySelector("#vote"+this.props.vid+"-"+index+" .voted").style.top = "100%";
			},2400);
	}

	openvote(){
		this.triggerEvent("Open vote overlay", this.props.vid);
		this.setState({showq: true})
	 }

	closevote(){
		this.setState({showq:false})
	}

	getButtonPath () {
		const {alldata} = this.state;

		/**
		 * In UNIX time
		 */
		const start = alldata.start_date ? (+(new Date(alldata.start_date))) : (+(new Date("1997-06-30T16:00:00Z")));
		const end = alldata.end_date ? (+(new Date(alldata.end_date))) : (+(new Date("2047-06-30T16:00:00Z")));
		const now = (+(new Date()));
		// Scenario 1 : The voting is ended
		if (now > end) { return '/assets-2021/img/endvoting.png'; }

		// Scenario 2 : On going
		if (now <= end && now > start) { return '/assets-2021/img/voting.png'; }

		// Scenario 3 : Not started
		if (now <= start) { return '/assets-2021/img/voting-not-started.png'; }

		return '';
	}

	render(){
		const {alldata, showq,pass} = this.state;
		const {vid, wstyle,index} = this.props;
		let that = this;

		// Show the loading icon.
		if (alldata === null) {
			return (
				<div className="vote-block vote-block--loading">
					<img src="/assets-2021/img/me-loading.png" />
				</div>
			);
		}

		const first = alldata.options.slice(0,3);
		const half= Math.floor(alldata.options.length / 2);
		const firsthalf = alldata.options.slice(0, half);
		const lasthalf = alldata.options.slice(half, alldata.options.length);
		const btnpath = this.getButtonPath();
		let votebgpath;
		if (alldata.bgimg !=null && alldata.bgimg !=""&& alldata.bgimg != false){
			 votebgpath = alldata.bgimg;
		}else{
			 votebgpath ='/assets-2021/img/mirror.png';
		}

		return(
			<div className="vote-block">

				<div className="vote-out">
					<div className="votenow"><img  src={btnpath} onClick={that.openvote.bind(this)}/></div>
				<h2>{alldata.name}</h2>
					<p>Total Votes : {(typeof alldata.votes !== 'undefined' ? alldata.votes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '')}</p>
					<div className="vote-img" onClick={that.openvote.bind(this)}>
						<img className="votenow-m" src={btnpath} onClick={that.openvote.bind(this)}/>
						<slider>

						</slider>
						<img src={alldata.img} />
					</div>
					<div className="vote-first" onClick={that.openvote.bind(this)}>
						{
							first?
							first.map(function(item, index) {
								let style = {
									width: (item.vote/alldata.votes*100)+'%',
								}
								return (
									<div  className="option">
										<div className={"option-img option"+index}>
											<img src={item.img} />
										</div>
										<div className="option-detail" >
												<div className={"voteno "+ wstyle} style={style}></div>
												<div className="option-visual"><div className={"option-no option"+index}>
													<div className="backlogo" style={{backgroundImage: `url(${votebgpath})` }}/></div>
													<div className="vote-detail"><span className="name">{item.name}</span><br/><span className="vote-num">{item.vote.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}票</span></div></div>
										</div>
									</div>

								)
							}):''
						}
					</div>
					{showq?
						<div>
							<div className="overlay-bg" onClick={that.closevote.bind(this)}></div>

						<div className="overlay-vote">
							<div onClick={that.closevote.bind(this)} className="voteclose">
								<i className="icon-close-01"></i>

							</div>
							<div className="vote-top">
								<div className="img"><img src={alldata.img} /></div>
								<div className="title"><p>{alldata.name}</p></div>
							</div>
							<div className="vote-end">
								{/* NOTE : It's UTC time, which is same as 香港時間10月15日中午12時正 */}
								<TimeCountdown time={alldata.end_date} />
							</div>
							<div className="whole-option">
								<div className="half-option">
									{

										firsthalf?

											firsthalf.map(function(item, index) {
												let style = {
													width: (item.vote/alldata.votes*100)+'%',
												}
												let vindex = index +1;
												return (

													<div  className={"option option"+index}>
														<div className={"option-img option"+index} onClick={that.vote.bind(this,item.index, index,alldata.end_date)}>
															<img src={item.img} />
														</div>
														<div className="option-detail" id={"vote"+vid+"-"+item.index}>
															<div className="voted" >
																<img src="/assets-2021/img/voted.png"/>
															</div>
															<div className="vote-whole" onClick={that.vote.bind(this,item.index, index,alldata.end_date)}>
																<div className={"voteno "+ wstyle} style={style}>

																</div>
																<div className="option-visual">
																	<div className={"option-no option"+index}>
																		<img src={"/assets-2021/img/vote"+vindex+".svg"}/>
																		<div className="backlogo" style={{backgroundImage: `url(${votebgpath})` }}></div>
																</div>
																	<div className="vote-detail"><span className="name">{item.name}</span><br/><span className="vote-num">{item.vote.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}票</span></div></div>
															</div>

														</div>
													</div>
												)
											}):''
									}
								</div>
								<div className="half-option">
									{

										lasthalf?

											lasthalf.map(function(item, index) {
												let style = {
													width: (item.vote/alldata.votes*100)+'%',
												}
												let tindex = index + half;
												let vindex = tindex + 1;
												return (
													<div  className={"option option"+tindex} >
														<div className={"option-img option"+tindex} onClick={that.vote.bind(this,item.index, tindex,alldata.end_date)}>
															<img src={item.img} />
														</div>
														<div className="option-detail" id={"vote"+vid+"-"+item.index}>
															<div className="voted">
																<img src="/assets-2021/img/voted.png"/>
															</div>
															<div  className="vote-whole" onClick={that.vote.bind(this,item.index, tindex,alldata.end_date)}>
																<div className={"voteno "+ wstyle} style={style}>

																</div>
																<div className="option-visual">
																	<div className={"option-no option"+tindex}>
																		<img src={"/assets-2021/img/vote"+vindex+".svg"}/>
																		<div className="backlogo" style={{backgroundImage: `url(${votebgpath})` }}></div>
																	</div>
																	<div className="vote-detail">
																		<span className="name">{item.name}</span><br/>
																		<span className="vote-num">{item.vote.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}票</span></div></div>
															</div>

														</div>

													</div>
												)
											}):''
									}
								</div>
								<div className="total">Total Votes: {alldata.votes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</div>
							</div>

							{
								this.props.index?
									'':<div className="othervote">
										<div>
											<a href="/mirror-error/voting/"><img src="/assets-2021/img/othervote.png"/></a>
										</div>
									</div>
							}



						</div>
						</div>
						:''

					}

				</div>
				{/*{*/}
				{/*	first?*/}
				{/*		first.map(function(item, index) {*/}
				{/*			return (*/}
				{/*				<div onClick={that.vote.bind(this,item.index)} className="option">*/}
				{/*					<div className={"option-img option"+index}>*/}
				{/*						<img src={item.img} />*/}
				{/*					</div>*/}
				{/*					<div className="option-detail">*/}
				{/*						{item.name}*/}
				{/*					</div>*/}
				{/*				</div>*/}

				{/*			)*/}
				{/*		}):''*/}
				{/*}*/}

				{
					this.props.index?
						'':<div className="othervote">
							<a href="/mirror-error/voting/"><img src="/assets-2021/img/othervote.png"/></a>
						</div>
				}

			</div>
		)


	}


}


const timeConstant = (function () {
	const second = 1000;
	const minute = second * 60;
	const hour = minute * 60;
	const day = hour * 24;
	return {second, minute, hour, day};
})();

function TimeCountdown (props) {
	const {time} = props;
    const timeDiff = (+(new Date(time))) - (+(new Date()));
	const [timeParts, setTimeParts] = useState({});

	useEffect(() => {
		let unmounted = false;

		function tick () {
            const timeDiff = (+(new Date(time))) - (+(new Date()));
			let timeLeft = timeDiff;
			const days = Math.floor(timeLeft / timeConstant.day);
			timeLeft -= timeConstant.day * days;
			const hours = Math.floor(timeLeft / timeConstant.hour);
			timeLeft -= timeConstant.hour * hours;
			const minutes = Math.floor(timeLeft / timeConstant.minute);
			timeLeft -= timeConstant.minute * minutes;
			const seconds = Math.floor(timeLeft / timeConstant.second);

            if (
                days !== timeParts.days ||
                hours !== timeParts.hours ||
                minutes !== timeParts.minutes ||
                seconds !== timeParts.seconds
            ) {
    			setTimeParts({days, hours, minutes, seconds});
            } else {
                if (!unmounted) { window.requestAnimationFrame(tick); }
            }
		}

		tick();

		return () => { unmounted = true; }
	}, [time, timeParts]);


	if (!timeParts.hasOwnProperty("days") || !timeParts.hasOwnProperty("hours") || !timeParts.hasOwnProperty("minutes") || !timeParts.hasOwnProperty("seconds")) {
		return null;
	}

    if (timeDiff <= 0) {
        // TODO : change the sentense representation
        return <p>是次投票活動已經結束，下一個投票即將開始。</p>
    }

	// TODO : change the sentense representation
	return <p>截止投票時間: <span>{timeParts.days}</span> d <span>{timeParts.hours}</span> h <span>{timeParts.minutes}</span> m</p>
}

export default Voting



// WEBPACK FOOTER //
// ./src/Voting.js